/**
 * Confirmation before a customer makes a supplier its Logistics Provider.
 *
 * Turning it on shows the supplier the customer's confirmed, dispatched and
 * delivered call-offs from EVERY supplier (without prices), so the customer
 * accepts that explicitly. Turning it off needs no confirmation.
 */
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from '../../components/ui/alert-dialog';

interface LogisticsProviderConfirmDialogProps {
  /** Supplier being made a carrier; null closes the dialog. */
  supplierName: string | null;
  /** Customer organisation (or site) the switch applies to. */
  orgLabel: string;
  siteCount: number;
  onConfirm: () => void;
  onCancel: () => void;
}

export default function LogisticsProviderConfirmDialog({
  supplierName, orgLabel, siteCount, onConfirm, onCancel,
}: LogisticsProviderConfirmDialogProps) {
  const sites = siteCount === 1 ? 'its site' : `all ${siteCount} of its sites`;
  return (
    <AlertDialog open={supplierName !== null} onOpenChange={(open) => { if (!open) onCancel(); }}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Make {supplierName} a Logistics Provider?</AlertDialogTitle>
          <AlertDialogDescription>
            {supplierName} will see confirmed, dispatched and delivered call-offs from all of
            your suppliers for {orgLabel} ({sites}), without prices. Its Call-Off tab will show
            these in place of its own call-off screens.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
          <AlertDialogAction onClick={onConfirm}>Make Logistics Provider</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
